import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { parseUrlQuery } from 'utilities'
import { GET_ACTIVE_DIRECTORY_REDIRECT } from 'requests'
import ls from 'local-storage'
import { Redirect } from 'react-router-dom'
import { setErrorToast } from '../../actions'
import LoginRedirector from '../LoginRedirector/LoginRedirector'
import { Spinner } from '../Loaders/Loaders'


let ActiveDirectoryRedirector = ({ location, history, checkingAuthState, loggedIn, stateUser }) => {
  const dispatch = useDispatch()
  React.useEffect(() => {
    if (!checkingAuthState && !loggedIn && stateUser) {
      const search = parseUrlQuery(location.search)
      const returnUrl = search.from || '/'
      ls.set('ACTIVE_DIRECTORY_RETURN_URL', returnUrl)
      GET_ACTIVE_DIRECTORY_REDIRECT(({ URLSTRING }) => {
        if (URLSTRING) {
          window.location.href = URLSTRING
        }
      },
        err => {
          dispatch(setErrorToast(err.Message))
        })
    }
  }, [checkingAuthState, loggedIn, stateUser])
  if (!checkingAuthState && loggedIn && stateUser) {
    return <Redirect to="/" />
  }
  if (!stateUser) {
    return <LoginRedirector location={location} history={history} />
  }
  return <Spinner className='loader' size='large' />
}
export default connect(state => ({
  checkingAuthState: state.auth.checkingAuthState,
  loggedIn: state.auth.loggedIn,
  stateUser: state.app.stateUser
}))(ActiveDirectoryRedirector)


// WEBPACK FOOTER //
// ./src/components/ActiveDirectory/ActiveDirectoryRedirector.js